import React from 'react';

import { useDispatch } from '../../../redux/hooks';
import { setWatchlistNotificationMode, toggleWatchlistActive } from '../../../redux/actions/watchlists';
import toast from '../../../utils/toast';
import { WatchlistNotificationMode } from '../formatWatchlist';

/** Saves a NotificationModeControl choice for an existing watchlist; API errors are shown as a toast. */
export default function useWatchlistNotificationMode(
    watchlist: { id: number | string, name: string | null },
    onSaved?: () => void
) {
    const dispatch = useDispatch();
    const [isSaving, setIsSaving] = React.useState(false);

    const select = React.useCallback(async (mode: WatchlistNotificationMode) => {
        setIsSaving(true);
        try {
            if (mode === 'off') {
                await dispatch(toggleWatchlistActive(watchlist.id, false));
            } else {
                await dispatch(setWatchlistNotificationMode(watchlist.id, mode));
            }
            onSaved?.();
        } catch (err: any) {
            toast(err?.message || `Kunde inte ändra ${watchlist.name || 'bevakningen'}, försök igen`);
        } finally {
            setIsSaving(false);
        }
    }, [dispatch, onSaved, watchlist.id, watchlist.name]);

    return { select, isSaving };
}
